module.exports = __webpack_public_path__ + "static/img/ISSUE10.e70218a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue10/ISSUE10.png
// module id = RBgh
// module chunks = 7